import type { ReactNode } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  type ButtonProps,
} from "@mui/material";

interface ConfirmModalProps {
  title: string;
  text: string;
  btnText: string;
  open: boolean;
  cancelBtn?: boolean;
  btnColor?: ButtonProps["color"];
  // Confirmação em voo no servidor: trava os dois botões, senão um duplo clique em "confirmar"
  // dispara a mutação duas vezes antes da primeira resposta voltar.
  loading?: boolean;
  // Abaixo do texto, como uma caixa que o usuário marca antes de confirmar.
  children?: ReactNode;
  // Trava só o botão de confirmar, enquanto falta algo no conteúdo.
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}

export function ConfirmModal({
  title,
  text,
  btnText,
  open,
  cancelBtn = true,
  btnColor = "error",
  loading = false,
  children,
  confirmDisabled = false,
  onConfirm,
  onClose,
}: ConfirmModalProps) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Typography sx={{ whiteSpace: "pre-line" }}>
          {text}
        </Typography>
        {children}
      </DialogContent>

      <DialogActions>
        {cancelBtn && (
          <Button onClick={onClose} variant="outlined" disabled={loading}>
            Cancelar
          </Button>
        )}

        <Button
          onClick={onConfirm}
          variant="contained"
          color={btnColor}
          disabled={loading || confirmDisabled}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {btnText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
